

// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import {
//   LuLayoutDashboard,
//   LuUsers,
//   LuMessageSquareText,
//   LuMessageCircle,
//   LuPhoneCall,
//   LuUserCog,
//   LuCog
// } from 'react-icons/lu';
// import { IoArrowBack } from 'react-icons/io5';


// const DashSide = ({ onNavigate, activePage }) => {
//   const navigate = useNavigate();

//   const navItems = [
//     { name: 'dashboard', label: 'Dashboard', icon: <LuLayoutDashboard size={20} /> },
//     { name: 'users', label: 'Users', icon: <LuUsers size={20} /> },
//     { name: 'messages', label: 'Messages', icon: <LuMessageSquareText size={20} /> },
//     { name: 'livechat', label: 'Live Chat', icon: <LuMessageCircle size={20} /> },
//     { name: 'contacts', label: 'Contacts', icon: <LuPhoneCall size={20} /> },
//     { name: 'agents', label: 'Agents', icon: <LuUserCog size={20} /> },
//     { name: 'setting', label: 'Setting', icon: <LuCog size={20} />  },
//   ];

//   return (
//     <div className="bg-[#0f172a] text-white w-20 min-h-screen p-3 flex flex-col justify-between shadow-lg border-r border-gray-800">
//       <div>
//         <h2 className="text-sm font-semibold mb-10 text-center tracking-widest text-cyan-400">
//           ADMIN
//         </h2>

//         <nav className="flex flex-col gap-6 items-center">
//           {navItems.map((item) => (
//             <div
//               key={item.name}
//               onClick={() => onNavigate(item.name)}
//               className={`group flex flex-col items-center cursor-pointer transition-all duration-300 ease-in-out ${
//                 activePage === item.name ? 'text-white' : 'text-gray-400 hover:text-white'
//               }`}
//             >
//               <div
//                 className={`p-2 rounded-full mb-1 transition-all duration-300 transform group-hover:scale-100 ${
//                   activePage === item.name
//                     ? 'bg-gradient-to-tr from-cyan-500 to-blue-600 shadow-md'
//                     : 'bg-[#0f172a] group-hover:bg-slate-700'
//                 }`}
//               >
//                 <div className="text-white drop-shadow-md">{item.icon}</div>
//               </div>
//               <span className="text-[10px] font-medium group-hover:translate-y-[-1px] group-hover:opacity-100 transition-all duration-200">
//                 {item.label}
//               </span>
//             </div>
//           ))}
//         </nav>
//       </div>

//       {/* Back Button */}
//       {/* <div className="pt-6">
//         <button
//           onClick={() => navigate('/')}
//           className="w-full bg-gradient-to-r from-slate-700 to-slate-800 hover:from-slate-600 hover:to-slate-700 transition-all text-white font-semibold py-2 px-3 rounded-xl flex items-center justify-center gap-2 text-xs shadow-md border border-slate-600 hover:border-slate-500"
//         >
//           <IoArrowBack size={14} /> Back
//         </button>
//       </div> */}
//     </div>
//   );
// };

// export default DashSide;



import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LuLayoutDashboard, LuUsers, LuMessageSquareText, LuMessageCircle, LuPhoneCall, LuUserCog, LuCog } from 'react-icons/lu';


const SUPERADMIN_EMAIL = 'onex@woodiewin.com';

const menuItems = [
  { name: 'dashboard', label: 'Dashboard', icon: <LuLayoutDashboard size={20} /> },
  { name: 'users', label: 'Users', icon: <LuUsers size={20} /> },
  { name: 'messages', label: 'Messages', icon: <LuMessageSquareText size={20} /> },
  { name: 'livechat', label: 'Live Chat', icon: <LuMessageCircle size={20}/> },
  { name: 'contacts', label: 'Contacts', icon: <LuPhoneCall size={20} /> },
  { 
    name: 'agents', 
    label: 'Agents', 
    icon: <LuUserCog size={20} />,
    isSuperAdmin: true 
  },
  { name: 'setting', label: 'Setting', icon: <LuCog size={20} /> }
];

const DashSide = ({ onNavigate, activePage, authUser, className  }) => {
  const navigate = useNavigate();
  const userEmail = authUser?.email?.toLowerCase();

  return (
    // <div className="bg-[#0f172a] text-white w-20 min-h-screen p-3 flex flex-col justify-between shadow-lg border-r border-gray-800">
    <div className={`bg-[#0f172a] text-white w-20 min-h-screen p-3 flex flex-col justify-between shadow-lg border-r border-gray-800 ${className || ''}`}>
      <div>
        <h2 className="text-sm font-semibold mb-10 text-center tracking-widest text-cyan-400">
          ADMIN
        </h2>

        <nav className="flex flex-col gap-6 items-center">
          {menuItems
            .filter(item => {
              if(item.isSuperAdmin) {
                return userEmail === SUPERADMIN_EMAIL?.toLowerCase();
              }
              return true;
            })
            .map((item) => (
              <div
                key={item.name}
                onClick={() => onNavigate(item.name)}
                className={`group flex flex-col items-center cursor-pointer transition-all duration-300 ease-in-out ${
                  activePage === item.name ? 'text-white' : 'text-gray-400 hover:text-white'
                }`}
              >
                <div
                  className={`p-2 rounded-full mb-1 transition-all duration-300 transform group-hover:scale-100 ${
                    activePage === item.name
                      ? 'bg-gradient-to-tr from-cyan-500 to-blue-600 shadow-md'
                      : 'bg-[#0f172a] group-hover:bg-slate-700'
                  }`}
                >
                  <div className="text-white drop-shadow-md">{item.icon}</div>
                </div>
                <span className="text-[10px] font-medium group-hover:translate-y-[-1px] group-hover:opacity-100 transition-all duration-200">
                  {item.label}
                </span>
              </div>
            ))}
        </nav>
      </div>
    </div>
  );
};

export default DashSide;